import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<div class=\"cNO--postWrapper\">\n  <div class=\"cNO--postWrapper__profile\">\n    <Shared::ProfileAvatar\n      @showDetails={{@socialProfile}}\n      @showOutline={{true}}\n      @showPlatform={{@socialProfile}}\n      @size=\"medium\"\n      @socialProfile={{@socialProfile}}\n      class=\"cNO--postWrapper__avatar\"\n    >\n      {{#unless @socialProfile}}\n        <span class=\"o--user__title\">\n          <span class=\"u--ellipsis\">{{this.socialProfileName}}</span>\n        </span>\n        <span class=\"o--user__desc\">\n          {{this.socialProfileType}}\n        </span>\n      {{/unless}}\n    </Shared::ProfileAvatar>\n  </div>\n  <div class=\"cNO--postWrapper__post\">\n    <div class=\"cNO--postWrapper__postInfo\">\n      <span>{{this.postTypeText}}</span>\n      <span>\n        {{svg-jar \"notification\" class=\"o--icon--xs\"}}\n        {{this.formattedDate}}\n      </span>\n    </div>\n    <picture class=\"cNO--postWrapper__postImage\">\n      <source srcset={{@post.smallThumbnailUrl}} type=\"image/jpg\" />\n      <source srcset={{@notificationData.post_thumbnail_url}} type=\"image/jpg\" />\n      <img alt=\"\" class=\"cNO--postWrapper__postImage\" src=\"/assets/images/img--failedToLoad.png\" />\n    </picture>\n  </div>\n</div>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<div class=\"cNO--postWrapper\">\n  <div class=\"cNO--postWrapper__profile\">\n    <Shared::ProfileAvatar\n      @showDetails={{@socialProfile}}\n      @showOutline={{true}}\n      @showPlatform={{@socialProfile}}\n      @size=\"medium\"\n      @socialProfile={{@socialProfile}}\n      class=\"cNO--postWrapper__avatar\"\n    >\n      {{#unless @socialProfile}}\n        <span class=\"o--user__title\">\n          <span class=\"u--ellipsis\">{{this.socialProfileName}}</span>\n        </span>\n        <span class=\"o--user__desc\">\n          {{this.socialProfileType}}\n        </span>\n      {{/unless}}\n    </Shared::ProfileAvatar>\n  </div>\n  <div class=\"cNO--postWrapper__post\">\n    <div class=\"cNO--postWrapper__postInfo\">\n      <span>{{this.postTypeText}}</span>\n      <span>\n        {{svg-jar \"notification\" class=\"o--icon--xs\"}}\n        {{this.formattedDate}}\n      </span>\n    </div>\n    <picture class=\"cNO--postWrapper__postImage\">\n      <source srcset={{@post.smallThumbnailUrl}} type=\"image/jpg\" />\n      <source srcset={{@notificationData.post_thumbnail_url}} type=\"image/jpg\" />\n      <img alt=\"\" class=\"cNO--postWrapper__postImage\" src=\"/assets/images/img--failedToLoad.png\" />\n    </picture>\n  </div>\n</div>","moduleName":"later/components/nav/notification/post-profile.hbs","parseOptions":{"srcName":"later/components/nav/notification/post-profile.hbs"}});
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { GenericData } from '@knocklabs/types';
import type IntlService from 'ember-intl/services/intl';
import type GramModel from 'later/models/gram';
import type SocialProfileModel from 'later/models/social-profile';
import type LocaleService from 'later/services/locale';
import type { Maybe } from 'shared/types';

interface PostProfileSignature {
  Element: HTMLDivElement;
  Args: {
    post: GramModel;
    socialProfile: Maybe<SocialProfileModel>;
    notificationData: GenericData;
  };
  Blocks: {
    default: [];
  };
}

export default class PostProfileComponent extends Component<PostProfileSignature> {
  @service declare intl: IntlService;
  @service declare locale: LocaleService;

  get socialProfileName(): string {
    if (this.args.socialProfile?.isInstagram) {
      return `@${this.args.notificationData.social_profile_name}`;
    }

    return this.args.notificationData.social_profile_name;
  }

  get socialProfileType(): string {
    if (this.args.socialProfile) {
      return this.args.socialProfile.localizedAccountType;
    }

    if (this.args.notificationData.social_profile_type) {
      return this.args.notificationData.social_profile_type;
    }

    return this.intl.t('shared_phrases.social_profile');
  }

  get postTypeText(): string {
    if (this.args.notificationData?.is_draft || this.args.post?.isDraft) {
      return this.intl.t('notifications.post_types.draft');
    }

    return this.intl.t('notifications.post_types.scheduled');
  }

  get formattedDate(): string {
    if (this.args.post?.scheduledTime) {
      return this.#formatDateTime().format(this.args.post.scheduledTime * 1000);
    }

    if (this.args.notificationData?.scheduled_time && typeof this.args.notificationData?.scheduled_time === 'string') {
      const date = new Date(this.args.notificationData?.scheduled_time);
      return this.#formatDateTime().format(date);
    }

    if (this.args.notificationData?.scheduled_time && typeof this.args.notificationData?.scheduled_time === 'number') {
      return this.#formatDateTime().format(this.args.notificationData?.scheduled_time * 1000);
    }

    return '';
  }

  #formatDateTime(): Intl.DateTimeFormat {
    return new Intl.DateTimeFormat(this.locale.primaryLocale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  }
}
